
<div class="container">
  <div class="row">
    <div class="col">
      <p>Export a spreadsheet that can be copied into FIS</p>
    </div>
  </div>
  <div class="row">
    <div class="col"> </div>
    <div class="col"><a class="btn btn-primary btn-block" [downloadFile]="'/api/deploymentworkflow/export-fleet-information'" [params]="{deploymentId: deploymentId}"><span class="oi oi-cloud-download"></span> Export Fleet Information Form</a></div>
    <div class="col"> </div>
  </div>
</div>